<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="800"
    :title="title"
    alignCenter
    @close="handleClose"
  >
    <div class="content">
      <div class="upload-tabs">
        <div>
          <el-button :class="{ actived: currentTab == 'queue' }" @click="changeTabs('queue')">
            执行队列
          </el-button>
          <el-button :class="{ actived: currentTab == 'records' }" @click="changeTabs('records')">
            历史记录
          </el-button>
        </div>
        <div v-if="currentTab == 'records'">
          <el-input
            v-model="searchFileName"
            placeholder="请输入文件名称查询"
            @keyup.enter="handleSearch"
            @blur="handleSearch"
            @clear="handleSearch"
            clearable
          >
            <template #append>
              <el-button :icon="Search" /> </template
            ></el-input>
        </div>
      </div>
      <!-- 队列 -->
      <div v-if="currentTab == 'queue'">
        <el-table :data="queueTablePageData" :height="'53vh'" show-overflow-tooltip>
          <el-table-column
            label="文件名称"
            prop="fileName"
            column-key="fileName"
            :filters="getFilterList(tableData, 'fileName')"
            :filter-method="filterHandler"
            :filter-icon="Filter"
          ></el-table-column>
          <el-table-column label="执行进度" prop="percentage" width="200">
            <template #default="{ row }">
             <el-progress
                :percentage="(row.finishNum / row.totalNum).toFixed(4) * 100"
                :status="row.status == 1 ? '' : row.status == 2 ? 'success' : 'error'"
              />
            </template>
          </el-table-column>
          <el-table-column label="云手机数量" prop="total">
            <template #default="{ row }"> {{ row.finishNum }} / {{ row.totalNum }} </template>
          </el-table-column>
          <el-table-column label="功能/状态">
            <template #default="{ row }">
              <span class="status">
                <el-icon v-if="row.status == 1" color="var(--ev-primary-color)"
                  ><Loading class="el-icon-loading"/></el-icon>
                <el-icon v-if="row.status == 2" color="#67c23a"><SuccessFilled /></el-icon>
                <el-icon v-if="row.status == 3" color="red"><CircleCloseFilled /></el-icon>
                {{
                  row.status == 1
                    ? '执行中'
                    : row.status == 2
                      ? '执行完成'
                      : '执行失败'
                }}
              </span>
            </template>
          </el-table-column>
          <template #empty>
            <div class="empty-data">
              <img src="@/assets/noData.png" alt="" />
              <div>暂无执行记录</div>
            </div>
          </template>
        </el-table>
      </div>

      <!-- 记录 -->
      <div v-else>
        <el-table
          :data="recordsTablePageData"
          :height="'48vh'"
          show-overflow-tooltip
          row-key="uuid"
          virtual-scroll
          @expand-change="handleExpandChange"
        >
          <el-table-column type="expand">
            <template #default="{ row }">
              <div style="padding: 0 30px">
                <el-table
                  :data="row.deviceRecords || []"
                  style="width: 100%; margin: 0"
                  size="small"
                  virtual-scroll
                >
                  <el-table-column label="云手机名称" prop="cloudDeviceName" />
                  <el-table-column label="文件名称" prop="fileName" />
                  <el-table-column label="上传状态">
                    <template #default="{ row }">
                      <span class="status">
                        <el-icon v-if="row.status == 1" color="var(--ev-primary-color)"
                          ><Loading class="el-icon-loading" 
                        /></el-icon>
                        <el-icon v-if="row.status == 2" color="#67c23a"><SuccessFilled /></el-icon>
                        <el-icon v-if="row.status == 3" color="red"><CircleCloseFilled /></el-icon>
                        {{
                          row.status == '1'
                            ? '执行中'
                            : row.status == '2'
                              ? '执行完成'
                              : '执行失败'
                        }}
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="文件名称" prop="fileName" />
          <el-table-column label="云手机数量" prop="total">
            <template #default="{ row }"> {{ row.finishNum }} / {{ row.totalNum }} </template>
          </el-table-column>
          <el-table-column label="功能/状态" prop="status">
            <template #default="{ row }">
              <span class="status">
                <el-icon v-if="row.status == 1" color="var(--ev-primary-color)"
                  ><Loading class="el-icon-loading" 
                /></el-icon>
                <el-icon v-if="row.status == 2" color="#67c23a"><SuccessFilled /></el-icon>
                <el-icon v-if="row.status == 3" color="red"><CircleCloseFilled /></el-icon>
                {{
                  row.status == 1
                    ? '执行中'
                    : row.status == 2
                      ? '执行完成'
                      : '执行失败'
                }}
              </span>
            </template>
          </el-table-column>
          <template #empty>
            <div class="empty-data">
              <img src="@/assets/noData.png" alt="" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-pagination
          style="margin: 10px auto 0; text-align: right"
          :current-page="recordsPage"
          :page-size="recordsPageSize"
          :total="recordsTotal"
          @current-change="handleRecordsPageChange"
          @size-change="handleRecordsSizeChange"
          layout="total, prev, pager, next, sizes"
          :page-sizes="[100, 200, 500, 1000]"
        />
      </div>
    </div>
</ComDialog>
</template>

<script setup>
import { ref, defineExpose, computed } from 'vue'
import { SuccessFilled, Loading, CircleCloseFilled, Filter, Search } from '@element-plus/icons-vue'
import API_CONFIG from "../api.json";
import HttpService from "@/utils/request"

const dialogVisible = ref(false)
const title = ref('推送/安装进度')
const tableData = ref([])
const tableDataRecords = ref([])
const currentTab = ref('queue')
const recordsPage = ref(1)
const recordsPageSize = ref(100)
const searchFileName = ref('')

const handleClose = () => {
  dialogVisible.value = false
}

const open = () => {
  currentTab.value = 'queue'
  getExcutoryTaskInfoList()
  dialogVisible.value = true
}

const getExcutoryTaskInfoList = () => {
  HttpService.post(API_CONFIG.queryExcutoryTaskInfoList.url)
    .then((res) => {
      if (res.data.length) {
        tableData.value = res.data || []
      }
    })
    .catch((err) => {
    })
}

const handleSearch = () => {
  recordsPage.value = 1
  getMainTaskInfoList()
}

const getMainTaskInfoList = () => {
  const params = {
    pageDomain: {
      pageNum: recordsPage.value,
      pageSize: recordsPageSize.value
    },
    fileName: searchFileName.value.trim() ? searchFileName.value.trim() : undefined
  }
  HttpService.post(API_CONFIG.queryMainTaskInfoList.url, params)
    .then((res) => {
      if (res.data.data.length) {
        tableDataRecords.value = res.data.data || []
        recordsTotal.value = res.data.total || 0
      }
    })
    .catch((err) => {
    })
}

const changeTabs = (type) => {
  currentTab.value = type
  if (type === 'queue') {
    getExcutoryTaskInfoList()
  } else {
    getMainTaskInfoList()
  }
}

const filterHandler = (value, row, column) => {
  const property = column['property']
  return row[property] === value
}

const getFilterList = (data, prop) => {
  if (!Array.isArray(data) || !prop) return []
  const unique = Array.from(new Set(data.map((item) => item[prop])))
  return unique.filter((v) => v !== undefined && v !== null).map((v) => ({ text: v, value: v }))
}

const queueTotal = ref(0)
const recordsTotal = ref(0)

const queueTablePageData = computed(() => tableData.value)
const recordsTablePageData = computed(() => tableDataRecords.value)

const handleRecordsPageChange = (val) => {
  recordsPage.value = val
  getMainTaskInfoList()
}
const handleRecordsSizeChange = (val) => {
  recordsPageSize.value = val
  recordsPage.value = 1
  getMainTaskInfoList()
}

// 记录（历史记录）层级表展开行
const fetchDeviceRecords = async (taskId) => {
  const params = {
    taskUuidList: [taskId]
  }
  try {
    const res = await HttpService.post(API_CONFIG.querySubTaskInfoList.url, params)
    return res.data || []
  } catch (err) {
    return []
  }
}

// el-table expand 行异步加载设备记录（手风琴效果，只展开一行）
const expandedRowKey = ref(null)

const handleExpandChange = async (row, expandedRows) => {
  // 只允许展开当前点击的这一行
  expandedRowKey.value = row.taskId || row.uuid
  // 只保留当前行在expandedRows中
  expandedRows.splice(0, expandedRows.length, row)
  if (!row.deviceRecords) {
    row.deviceRecords = await fetchDeviceRecords(row.uuid)
  }
}

defineExpose({ open })
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  max-height: 65vh;
  .upload-tabs {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .actived {
      background: #007bff;
      color: #ffffff;
      border: none;
    }
  }
  .status {
    display: flex;
    align-items: center;
  }
}
.empty-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 30%;
  }
}

// 添加以下CSS动画样式确保Loading图标旋转
:deep(.el-icon-loading) {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
